module.exports = __webpack_public_path__ + "static/img/wiseBrainIcon1.0210435.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wiseBrainIcon1.png
// module id = E0jd
// module chunks = 1